import { render, staticRenderFns } from "./selected_date_label.vue?vue&type=template&id=278420de&scoped=true&lang=pug&"
import script from "./selected_date_label.vue?vue&type=script&setup=true&lang=js&"
export * from "./selected_date_label.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./selected_date_label.vue?vue&type=style&index=0&id=278420de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278420de",
  null
  
)

export default component.exports